/** Caller name: letters / spaces / common punctuation only G�� no digits. */

export const CALLER_NAME_NO_DIGITS_MSG =
  "Caller name cannot contain numbers. Use letters only.";

/** Strip digits while typing so numbers never appear in the field. */
export function normalizeCallerName(value) {
  return String(value ?? "").replace(/\d/g, "");
}

export function validateCallerNameField(value) {
  const t = String(value ?? "").trim();
  if (!t) return "Caller name is required";
  if (/\d/.test(t)) return CALLER_NAME_NO_DIGITS_MSG;
  return null;
}
